import { createBrowserRouter, RouterProvider } from "react-router-dom";
import React, { Suspense, lazy } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
 
const queryClient = new QueryClient();

// Lazy load components
const Layout = lazy(() => import("./components/Layout/Layout"));
const Home = lazy(() => import("./components/Home/Home"));
const Aboutus = lazy(() => import("./components/Aboutus/Aboutus"));
const Pricing = lazy(() => import("./components/Pricing/Pricing"));
const PreviousWork = lazy(() => import("./components/PreviousWork/PreviousWork"));
const Privacy = lazy(() => import("./components/Privacy/Privacy"));
const Condition = lazy(() => import("./components/Condition/Condition"));
const Projectdetails = lazy(() => import("./components/Projectdetails/Projectdetails"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Blogdetails = lazy(() => import("./components/Blogdetails/Blogdetails"));
const SendRequest = lazy(() => import("./components/SendRequest/SendRequest"));
const Blogs = lazy(() => import("./components/Blogs/Blogs"));


const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-[100vh]">
    <span className="loader my-8"></span>
  </div>
);

const routes = createBrowserRouter([
  {
    path: "/",
    element: (
      <>

        <Suspense fallback={<LoadingSpinner/>}>
          <Layout />
        </Suspense>
      </>
    ),
    children: [
      {
        index: true,
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Home />
            </Suspense>
          </>
        ),
      },
      {
        path: "about-us",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Aboutus />
            </Suspense>
          </>
        ),
      },
      {
        path: "pricing",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Pricing />
            </Suspense>
          </>
        ),
      },
      {
        path: "previous-work",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <PreviousWork />
            </Suspense>
          </>
        ),
      },
      {
        path: "privacy",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Privacy />
            </Suspense>
          </>
        ),
      },
      {
        path: "condition",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Condition />
            </Suspense>
          </>
        ),
      },
      {
        path: "project-details/:id",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Projectdetails />
            </Suspense>
          </>
        ),
      },
      {
        path: "blogs",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Blogs />
            </Suspense>
          </>
        ),
      },
      {
        path: "blog-details/:id",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Blogdetails />
            </Suspense>
          </>
        ),
      },
      {
        path: "send-request/:id",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <SendRequest />
            </Suspense>
          </>
        ),
      },
      {
        path: "send-request",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <SendRequest />
            </Suspense>
          </>
        ),
      },
      {
        path: "Contact",
        element: (
          <>

            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Contact />
            </Suspense>
          </>
        ),
      },
      {
        path: "*",
        element: (
          <>
            <Suspense fallback={<div className="flex justify-center items-center h-[100vh]"><span className="loader my-8"></span></div>}>
              <Home />
            </Suspense>
          </>
        ),
      },
    ],
  },
]);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={routes} />
    </QueryClientProvider>
  );
}

export default App;
